import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { CustomgridComponent } from './customgrid.component';
import { PipeModule } from '../pipes';
import { CustomgridBoutonConfigModule } from './customgrid-bouton-config/customgrid-bouton-config.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CheckboxEditor, ComboEditor, DatePickerEditor, CheckboxRenderer } from './agInput';

@NgModule({
  imports: [
    // AgGridModule.withComponents([CheckboxEditor, DatePickerEditor]),
    AgGridModule,
    CommonModule,
    FormsModule,
    PipeModule,
    CustomgridBoutonConfigModule,
    NgbModule,
  ],
  declarations: [
    CustomgridComponent,
    CheckboxEditor,
    DatePickerEditor,
    ComboEditor,
    CheckboxRenderer,
  ],
  exports: [
    CustomgridComponent,
  ]
})

export class CustomgridModule { }
